import Pusher, { Channel } from 'pusher-js'

export interface IWebSocket {
    connect: () => void
    disconnect: () => void
    subscribe: (channel: string) => Channel
    unsubscribe: (channel: string, event?: string) => void
}

class WebSocketService implements IWebSocket {
    private pusher!: Pusher
    private PUSHER_KEY = process.env.VUE_APP_PUSHER_KEY
    private PUSHER_OPTIONS = { cluster: 'us2' }
    static instance: WebSocketService;

    constructor() {
        if (!WebSocketService.instance) {

            this.pusher = new Pusher(this.PUSHER_KEY, this.PUSHER_OPTIONS);

            setTimeout(() => {
                const state = this.pusher.connection.state;
                console.log(state)
                if (state !== "connected") {
                    console.error("DEU RUIM NO PUSHER");
                }
            }, 15000);

            WebSocketService.instance = this;
        }

        return WebSocketService.instance;
    }

    connect = () => {
        this.pusher.connect();
    };

    subscribe = (channel: string) => {
        return this.pusher?.subscribe(channel);
    }

    unsubscribe = (channel: string, event?: string) => {
        this.pusher.unsubscribe(channel)
        if (event) {
            this.pusher.unbind(event)
        }
    }

    disconnect = () => {
        this.pusher.disconnect();
    };
}

const webSocketService = new WebSocketService();
export default webSocketService;